module.exports = __webpack_public_path__ + "img/2.1a1f723b.png";